module.exports = __webpack_public_path__ + "static/media/G4.dd54eb91.png";